// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhl_a bhl_x bhl_j bhl_u bhl_bc bhl_qj bhl_vt"};